import axios from "axios";

const url = "https://binod-bingo.herokuapp.com/auth";
const profileURl = "https://binod-bingo.herokuapp.com/profile";
const gameURl = "https://binod-bingo.herokuapp.com/game";

export const fetchUsers= () => axios.get(url);
export const signUpUser= (data) => axios.post(`${url}/signUp`,data);
export const signInUser= (data) => axios.post(`${url}/signIn`,data);
export const googleSignInUser= (data) => axios.post(`${url}/googleSignIn`,data);

export const getProfile = (email) => axios.get(`${profileURl}/getMyProfile/${email}`);
export const getOpponents = (email) => axios.get(`${profileURl}/getAllOpponents/${email}`);
export const getLeaderBoard = () => axios.get(`${profileURl}/getLeaderboardData`);
export const updatePlayerData = (email,data) => axios.patch(`${profileURl}/updateProfile/${email}`,data);
export const updatePlayerImage = (email, data) => axios.patch(`${profileURl}/updateImage/${email}`, data);

export const fetchRoom = (id) => axios.get(`${gameURl}/fetchRoomData/${id}`)
export const createRoom = (data) => axios.post(`${gameURl}/createPlayer`,data);
export const joinRoom = (data) => axios.post(`${gameURl}/joinPlayer`,data);
export const lockRoom = (roomID) => axios.patch(`${gameURl}/lockRoom/${roomID}`);
